import { LoadState } from '@diditusa/shared/types/commonTypes';
import { useCreateJobMutation } from '@diditusa/shared/api/jobsApi';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import LoadingIndicator from '@diditusa/shared/web_components/LoadingIndicator/loadingIndicator';
import { useNavigate } from 'react-router-dom';

import './jobs.css';

export default function JobsCreate() {
  const dispatch = useAppDispatch();
  const jobsState = useAppSelector((state) => state.root.jobsState);
  const navigate = useNavigate();
  const [description, setJobDescription] = useState('');
  const [startTime, setStartTime] = useState<Date | null>(new Date());
  const [durationHours, setDurationHours] = useState<number>(2);
  const [location, setLocation] = useState('');
  const [validationMsg, setValidationMsg] = useState('');
  const [createJob, { isLoading, isError }] = useCreateJobMutation();

  useEffect(() => {
    if (jobsState.createLoadState === LoadState.LOADED) {
      navigate('/');
    }
  }, [jobsState.createLoadState]);

  const onCreateClick = () => {
    if (!description) {
      setValidationMsg('Description is required');
      return;
    }

    if (!startTime) {
      setValidationMsg('Start time is required');
      return;
    }

    if (!durationHours) {
      setValidationMsg('Duration is required');
      return;
    }

    if (!location) {
      setValidationMsg('Location is required');
      return;
    }

    // fix this
    createJob({
      description,
      startTime,
      durationHours,
      location,
      securityOptionId: 1,
      securityOptionPricingId: 1,
    });
  };

  return (
    <div className={'create-companies-container'}>
      {isError && <p style={{ color: 'red' }}>Error creating job. Please try again.</p>}
      <h1>Create Job</h1>
      <div className={'create-companies-form'}>
        <LoadingIndicator isVisible={jobsState.createLoadState === LoadState.LOADING} />
        <label>Job Description</label>
        <input
          value={description}
          onChange={(e) => {
            setJobDescription(e.currentTarget.value);
          }}
        />
        <label>Start time</label>
        <input
          value={startTime?.toString()}
          type={'date'}
          onChange={(e) => {
            setStartTime(new Date(e.currentTarget.value));
          }}
        />
        <label>Duration (in hours)</label>
        <input
          type={'number'}
          value={durationHours}
          onChange={(e) => {
            setDurationHours(parseInt(e.currentTarget.value));
          }}
        />
        <label>Location</label>
        <input
          value={location}
          onChange={(e) => {
            setLocation(e.currentTarget.value);
          }}
        />
        {!!validationMsg && <p>{validationMsg}</p>}
        <button onClick={onCreateClick} disabled={jobsState.createLoadState === LoadState.LOADING}>
          Create
        </button>
      </div>
    </div>
  );
}
